import React from 'react';
import { Box, Typography, Avatar, Chip } from '@mui/material';
import { CircularScore, ScoreBar } from './ScoreWidgets';

const MEDALS = ['#f59e0b', '#94a3b8', '#b45309'];

const CandidatCard = ({ candidat, index, isSelected, onClick }) => {
    const scoreGlobal = Math.round((candidat.score ?? 0) * 100);
    const props = candidat.properties || {};

    const fullName = (props.full_name && props.full_name !== 'null') ? props.full_name : '';
    const nameParts = fullName.trim().split(' ');
    const initiales = ((nameParts[0]?.charAt(0) || '') + (nameParts[1]?.charAt(0) || '')).toUpperCase() || '?';

    const indScores = candidat.individual_scores || null;
    const techSkills = Array.isArray(props.technical_skills) ? props.technical_skills : [];
    const subtitle = [
        props.years_of_experience > 0 ? `${props.years_of_experience} ans d'exp.` : null,
        props.location && props.location !== 'not found' ? props.location : null,
    ].filter(Boolean).join(' • ');
    const medal = MEDALS[index];

    return (
        <Box
            role="button"
            tabIndex={0}
            onClick={onClick}
            onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && onClick()}
            sx={{
                mb: 1, p: 1.5, borderRadius: '12px', cursor: 'pointer', transition: 'all 0.15s ease',
                border: `1.5px solid ${isSelected ? '#03407b' : '#e2e8f0'}`,
                background: isSelected ? '#f0f7fd' : '#fff',
                '&:hover': { borderColor: isSelected ? '#03407b' : '#aed6f1', boxShadow: '0 4px 14px rgba(3,64,123,0.08)' },
                '&:focus-visible': { outline: '2px solid #aed6f1', outlineOffset: 2 },
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
                <Box sx={{
                    width: 26, height: 26, borderRadius: '8px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: '0.72rem', fontWeight: 800,
                    background: medal ? medal : '#f1f5f9', color: medal ? '#fff' : '#64748b',
                }}>
                    {index + 1}
                </Box>
                <Avatar sx={{ width: 38, height: 38, bgcolor: '#ebf4fb', color: '#03407b', fontWeight: 700, fontSize: '0.85rem' }}>
                    {initiales}
                </Avatar>
                <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography sx={{ fontSize: '0.92rem', fontWeight: 700, color: '#0f172a', lineHeight: 1.25, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {fullName || <span style={{ color: '#94a3b8', fontStyle: 'italic', fontWeight: 500 }}>Nom non disponible</span>}
                    </Typography>
                    {subtitle && (
                        <Typography sx={{ fontSize: '0.76rem', color: '#64748b', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{subtitle}</Typography>
                    )}
                </Box>
                <CircularScore score={scoreGlobal} />
            </Box>

            {indScores && (
                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: 2, mt: 1.25 }}>
                    {indScores.core_skills_score != null && <ScoreBar label="Compétences" score={Math.round(indScores.core_skills_score * 100)} />}
                    {indScores.language_score != null && <ScoreBar label="Langues" score={Math.round(indScores.language_score * 100)} />}
                    {indScores.role_score != null && <ScoreBar label="Rôle" score={Math.round(indScores.role_score * 100)} />}
                    {indScores.seniority_score != null && <ScoreBar label="Séniorité" score={Math.round(indScores.seniority_score * 100)} />}
                </Box>
            )}

            {techSkills.length > 0 && (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
                    {techSkills.slice(0, 5).map((skill, i) => (
                        <Chip key={i} label={skill} size="small" sx={{ height: 20, fontSize: '0.68rem', color: '#475569', background: '#f1f5f9' }} />
                    ))}
                    {techSkills.length > 5 && (
                        <Chip label={`+${techSkills.length - 5}`} size="small" sx={{ height: 20, fontSize: '0.68rem', color: '#03407b', background: '#ebf4fb', fontWeight: 700 }} />
                    )}
                </Box>
            )}
        </Box>
    );
};

export default CandidatCard;
